import Homepage from "./pages/Homepage";
import "./styles/style.css"



function App() {
  return (
    <div>
      <Homepage />
    
    </div>
  );
}

export default App;
